import { AwsRum, type AwsRumConfig } from 'aws-rum-web'

let rumClient: AwsRum | null = null

export function initRum(): void {
  const appId = import.meta.env.VITE_CLOUDWATCH_RUM_APP_ID
  const identityPoolId = import.meta.env.VITE_CLOUDWATCH_RUM_IDENTITY_POOL_ID
  const region = import.meta.env.VITE_CLOUDWATCH_RUM_REGION

  if (!appId || !identityPoolId || !region) return

  const config: AwsRumConfig = {
    sessionSampleRate: 1,
    identityPoolId,
    endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
    telemetries: ['errors', 'http'],
    allowCookies: true,
    enableXRay: false,
  }

  rumClient = new AwsRum(appId, '1.0.0', region, config)
}

export function reportError(
  error: unknown,
  metadata?: Record<string, unknown>
): void {
  rumClient?.recordEvent('tsp_error', {
    errorMessage: error instanceof Error ? error.message : String(error),
    errorName: error instanceof Error ? error.name : 'UnknownError',
    errorStack: error instanceof Error ? error.stack : undefined,
    ...metadata,
  })
}
